import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjhr46jqeb: FaireProductEntity = {
  token: "p_yjhr46jqeb",
  type: "product",
  name: "Blue Crystal Ashtray",
  brandToken: "b_6k5xkw1g4n",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/36f1273e8ffe6f62e1ca7bb5f6c29dce0108ff01b3078c89e02ddb3d569a837d.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.97,
  description: "Blue Crystal Geod Ashtray \n4 1/4 inches wide\nHand Painted Cold Cast Resin",
  tags: [],
  msrpDollars: 15.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:57.971Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
